import type { FaireProductEntity } from "../../entity_types/product";

export const p_nk6yjqcds3: FaireProductEntity = {
  token: "p_nk6yjqcds3",
  type: "product",
  name: "Boiron - Sleepcalm (sleep Relief) - 1 Each 1-60 Tab",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/60b990e89923364c56fd289ef9eb9f15dc1a324b493a8d512a5f13a31fddf074.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b6e9aae08404695196a8a74db2ef4f6cd9c38de2e1850653ed8dc402ba0cb80.jpeg",
  ],
  priceDollars: 14.03,
  description:
    "\n\nSay goodbye to restless nights with this effective sleep aid that supports a restful and peaceful slumber. Perfect for those who struggle with occasional sleeplessness, this homeopathic solution comes in a convenient package containing 60 tablets. Enjoy the benefits of a non-habit forming formula that is gentle and calming. Here’s why this product stands out:\n\n * Non-drowsy formula that helps maintain natural sleep patterns \n * Suitable for adults and children aged 12 and up \n * Made with natural active ingredients for a soothing effect \nWith this sleep aid, you can wake up feeling refreshed and ready to face the day.\n",
  tags: [],
  msrpDollars: 28.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:31.357Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
